import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-1.jpg'
import _imports_1 from '@/assets/images/user-2.jpg'
import _imports_2 from '@/assets/images/user-3.jpg'
import _imports_3 from '@/assets/images/user-4.jpg'
import _imports_4 from '@/assets/images/user-5.jpg'
import _imports_5 from '@/assets/images/user-6.jpg'
import _imports_6 from '@/assets/images/user-7.jpg'
import _imports_7 from '@/assets/images/user-8.jpg'


const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Basic Chips"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex flex-wrap gap-2" }, [
                _createElementVNode("button", { class: "btn btn-primary text-white rounded-pill" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line text-white" }),
                    _createElementVNode("span", { class: "ms-1" }, "Primary")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-secondary text-white rounded-pill" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line text-white" }),
                    _createElementVNode("span", { class: "ms-1" }, "Secondary")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-success text-white rounded-pill" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line text-white" }),
                    _createElementVNode("span", { class: "ms-1" }, "Success")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-danger text-white rounded-pill" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line text-white" }),
                    _createElementVNode("span", { class: "ms-1" }, "Danger")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-warning text-white rounded-pill" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line text-white" }),
                    _createElementVNode("span", { class: "ms-1" }, "Warning")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-info text-white rounded-pill" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line text-white" }),
                    _createElementVNode("span", { class: "ms-1" }, "Info")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-light text-white rounded-pill" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line text-white" }),
                    _createElementVNode("span", { class: "ms-1" }, "Light")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-dark text-white rounded-pill" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line text-white" }),
                    _createElementVNode("span", { class: "ms-1" }, "Dark")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, "\n<button class=\"btn btn-primary text-white rounded-pill\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line text-white\"></i>\n<span class=\"ms-1\">Primary</span>\n</div>\n</button>\n<button class=\"btn btn-secondary text-white rounded-pill\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line text-white\"></i>\n<span class=\"ms-1\">Secondary</span>\n</div>\n</button>\n<button class=\"btn btn-success text-white rounded-pill\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line text-white\"></i>\n<span class=\"ms-1\">Success</span>\n</div>\n</button>\n<button class=\"btn btn-danger text-white rounded-pill\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line text-white\"></i>\n<span class=\"ms-1\">Danger</span>\n</div>\n</button>\n<button class=\"btn btn-warning text-white rounded-pill\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line text-white\"></i>\n<span class=\"ms-1\">Warning</span>\n</div>\n</button>\n<button class=\"btn btn-info text-white rounded-pill\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line text-white\"></i>\n<span class=\"ms-1\">Info</span>\n</div>\n</button>\n<button class=\"btn btn-light text-white rounded-pill\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line text-white\"></i>\n<span class=\"ms-1\">Light</span>\n</div>\n</button>\n<button class=\"btn btn-dark text-white rounded-pill\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line text-white\"></i>\n<span class=\"ms-1\">Dark</span>\n</div>\n</button>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Basic Chips With Icon Style"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex flex-wrap gap-2" }, [
                _createElementVNode("button", { class: "btn btn-primary text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle" }),
                    _createElementVNode("span", { class: "ms-1" }, "Primary")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-secondary text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle" }),
                    _createElementVNode("span", { class: "ms-1" }, "Secondary")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-success text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle" }),
                    _createElementVNode("span", { class: "ms-1" }, "Success")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-danger text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle" }),
                    _createElementVNode("span", { class: "ms-1" }, "Danger")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-warning text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle" }),
                    _createElementVNode("span", { class: "ms-1" }, "Warning")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-info text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle" }),
                    _createElementVNode("span", { class: "ms-1" }, "Info")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-light text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle" }),
                    _createElementVNode("span", { class: "ms-1" }, "Light")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-dark text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle" }),
                    _createElementVNode("span", { class: "ms-1" }, "Dark")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, "\n<button class=\"btn btn-primary text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle\"></i>\n<span class=\"ms-1\">Primary</span>\n</div>\n</button>\n<button class=\"btn btn-secondary text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle\"></i>\n<span class=\"ms-1\">Secondary</span>\n</div>\n</button>\n<button class=\"btn btn-success text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle\"></i>\n<span class=\"ms-1\">Success</span>\n</div>\n</button>\n<button class=\"btn btn-danger text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle\"></i>\n<span class=\"ms-1\">Danger</span>\n</div>\n</button>\n<button class=\"btn btn-warning text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle\"></i>\n<span class=\"ms-1\">Warning</span>\n</div>\n</button>\n<button class=\"btn btn-info text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle\"></i>\n<span class=\"ms-1\">Info</span>\n</div>\n</button>\n<button class=\"btn btn-light text-white rounded-pill px-2\">\n<div class=\"ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle\">\n<i class=\"ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle\"></i>\n<span class=\"ms-1\">Light</span>\n</div>\n</button>\n<button class=\"btn btn-dark text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line wh-25 bg-white text-primary fs-16 rounded-circle\"></i>\n<span class=\"ms-1\">Dark</span>\n</div>\n</button>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Chips With Image"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent3"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex flex-wrap gap-2" }, [
                _createElementVNode("button", { class: "btn btn-primary text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "rounded-circle wh-25",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Primary")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-secondary text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "rounded-circle wh-25",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Secondary")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-success text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "rounded-circle wh-25",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Success")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-danger text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      class: "rounded-circle wh-25",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Danger")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-warning text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      class: "rounded-circle wh-25",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Warning")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-info text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_5,
                      class: "rounded-circle wh-25",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Info")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-light text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_6,
                      class: "rounded-circle wh-25",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Light")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-dark text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_7,
                      class: "rounded-circle wh-25",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Dark")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, "\n<button class=\"btn btn-primary text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-1.jpg\" class=\"rounded-circle wh-25\" alt=\"user\">\n<span class=\"ms-1\">Primary</span>\n</div>\n</button>\n<button class=\"btn btn-secondary text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-2.jpg\" class=\"rounded-circle wh-25\" alt=\"user\">\n<span class=\"ms-1\">Secondary</span>\n</div>\n</button>\n<button class=\"btn btn-success text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-3.jpg\" class=\"rounded-circle wh-25\" alt=\"user\">\n<span class=\"ms-1\">Success</span>\n</div>\n</button>\n<button class=\"btn btn-danger text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-4.jpg\" class=\"rounded-circle wh-25\" alt=\"user\">\n<span class=\"ms-1\">Danger</span>\n</div>\n</button>\n<button class=\"btn btn-warning text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-5.jpg\" class=\"rounded-circle wh-25\" alt=\"user\">\n<span class=\"ms-1\">Warning</span>\n</div>\n</button>\n<button class=\"btn btn-info text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-6.jpg\" class=\"rounded-circle wh-25\" alt=\"user\">\n<span class=\"ms-1\">Info</span>\n</div>\n</button>\n<button class=\"btn btn-light text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-7.jpg\" class=\"rounded-circle wh-25\" alt=\"user\">\n<span class=\"ms-1\">Light</span>\n</div>\n</button>\n<button class=\"btn btn-dark text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-8.jpg\" class=\"rounded-circle wh-25\" alt=\"user\">\n<span class=\"ms-1\">Dark</span>\n</div>\n</button>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Chips With Image & Border"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab4",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview4-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code4-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent4"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex flex-wrap gap-2" }, [
                _createElementVNode("button", { class: "btn btn-primary text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "rounded-circle wh-25 border border-2 border-white",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Primary")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-secondary text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "rounded-circle wh-25 border border-2 border-white",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Secondary")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-success text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "rounded-circle wh-25 border border-2 border-white",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Success")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-danger text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      class: "rounded-circle wh-25 border border-2 border-white",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Danger")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-warning text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      class: "rounded-circle wh-25 border border-2 border-white",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Warning")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-info text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_5,
                      class: "rounded-circle wh-25 border border-2 border-white",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Info")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-light text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_6,
                      class: "rounded-circle wh-25 border border-2 border-white",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Light")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-dark text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_7,
                      class: "rounded-circle wh-25 border border-2 border-white",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Dark")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode4"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode4"
                }, "\n<button class=\"btn btn-primary text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-1.jpg\" class=\"rounded-circle wh-25 border border-2 border-white\" alt=\"user\">\n<span class=\"ms-1\">Primary</span>\n</div>\n</button>\n<button class=\"btn btn-secondary text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-2.jpg\" class=\"rounded-circle wh-25 border border-2 border-white\" alt=\"user\">\n<span class=\"ms-1\">Secondary</span>\n</div>\n</button>\n<button class=\"btn btn-success text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-3.jpg\" class=\"rounded-circle wh-25 border border-2 border-white\" alt=\"user\">\n<span class=\"ms-1\">Success</span>\n</div>\n</button>\n<button class=\"btn btn-danger text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-4.jpg\" class=\"rounded-circle wh-25 border border-2 border-white\" alt=\"user\">\n<span class=\"ms-1\">Danger</span>\n</div>\n</button>\n<button class=\"btn btn-warning text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-5.jpg\" class=\"rounded-circle wh-25 border border-2 border-white\" alt=\"user\">\n<span class=\"ms-1\">Warning</span>\n</div>\n</button>\n<button class=\"btn btn-info text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-6.jpg\" class=\"rounded-circle wh-25 border border-2 border-white\" alt=\"user\">\n<span class=\"ms-1\">Info</span>\n</div>\n</button>\n<button class=\"btn btn-light text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-7.jpg\" class=\"rounded-circle wh-25 border border-2 border-white\" alt=\"user\">\n<span class=\"ms-1\">Light</span>\n</div>\n</button>\n<button class=\"btn btn-dark text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-8.jpg\" class=\"rounded-circle wh-25 border border-2 border-white\" alt=\"user\">\n<span class=\"ms-1\">Dark</span>\n</div>\n</button>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Chips All Style"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab5",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview5-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code5-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent5"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex flex-wrap gap-2" }, [
                _createElementVNode("button", { class: "btn btn-primary text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-home-4-line text-white" }),
                    _createElementVNode("span", { class: "ms-1" }, "Primary")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-secondary text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "rounded-circle wh-25 border border-2 border-white",
                      alt: "user"
                    }),
                    _createElementVNode("span", { class: "ms-1" }, "Secondary")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-success text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-check-line wh-25 bg-white text-primary fs-16 rounded-circle" }),
                    _createElementVNode("span", { class: "ms-1" }, "Success")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-danger text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("i", { class: "ri-close-line wh-25 bg-white text-primary fs-16 rounded-circle" }),
                    _createElementVNode("span", { class: "ms-1" }, "Danger")
                  ])
                ]),
                _createElementVNode("button", { class: "btn btn-warning text-white rounded-pill px-2" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("span", { class: "me-2" }, "Warning"),
                    _createElementVNode("img", {
                      src: _imports_4,
                      class: "rounded-circle wh-25 border border-2 border-white",
                      alt: "user"
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode5"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode5"
                }, "\n<button class=\"btn btn-primary text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-home-4-line text-white\"></i>\n<span class=\"ms-1\">Primary</span>\n</div>\n</button>\n<button class=\"btn btn-secondary text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<img src=\"@/assets/images/user-2.jpg\" class=\"rounded-circle wh-25 border border-2 border-white\" alt=\"user\">\n<span class=\"ms-1\">Secondary</span>\n</div>\n</button>\n<button class=\"btn btn-success text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-check-line wh-25 bg-white text-primary fs-16 rounded-circle\"></i>\n<span class=\"ms-1\">Success</span>\n</div>\n</button>\n<button class=\"btn btn-danger text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<i class=\"ri-close-line wh-25 bg-white text-primary fs-16 rounded-circle\"></i>\n<span class=\"ms-1\">Danger</span>\n</div>\n</button>\n<button class=\"btn btn-warning text-white rounded-pill px-2\">\n<div class=\"d-flex align-items-center\">\n<span class=\"me-2\">Warning</span>\n<img src=\"@/assets/images/user-5.jpg\" class=\"rounded-circle wh-25 border border-2 border-white\" alt=\"user\">\n</div>\n</button>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}